import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';

import { createColumnDef } from 'src/components/NPIDataGrid/NPIDataGrid.utils';

import CheckInCallChip from './Chip';

export const CheckInCallsGridColDef = (handleView: ({ id }: { id: number }) => void) => {
    return [
        createColumnDef({
            field: 'id',
            headerName: 'Service ID',
        }),
        createColumnDef({
            field: 'merchantName',
            headerName: 'Merchant Name',
        }),
        createColumnDef({
            field: 'callName',
            headerName: 'Call Name',
        }),
        createColumnDef({
            field: 'days',
            headerName: 'Scheduled Call',
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <>
                        <CheckInCallChip days={params.value} />
                    </>
                );
            },
        }),
        createColumnDef({
            field: 'actions',
            disableColumnMenu: true,
            flex: 0,
            minWidth: 160 / 3,
            renderCell: (params: GridRenderCellParams) => {
                return (
                    <>
                        <IconButton
                            onClick={() => {
                                return handleView({ id: params.row.id });
                            }}
                            aria-label="view"
                        >
                            <VisibilityIcon />
                        </IconButton>
                    </>
                );
            },
        }),
    ];
};

export default CheckInCallsGridColDef;
